var map = {
	"./betting_icon.embedded.svg": 1240,
	"./champions_league.embedded.svg": 1241,
	"./conmebol_icon.embedded.svg": 1242,
	"./csgo_icon.embedded.svg": 1243,
	"./dfs_icon.embedded.svg": 1244,
	"./dota2_icon.embedded.svg": 1245,
	"./dr_pepper.embedded.svg": 1246,
	"./dreamhack_icon.embedded.svg": 1247,
	"./esl_icon.embedded.svg": 1248,
	"./fifa.embedded.svg": 1249,
	"./fnatic_icon.embedded.svg": 1250,
	"./fortnite.embedded.svg": 1251,
	"./i_league_icon.embedded.svg": 1252,
	"./logo-12up.embedded.svg": 530,
	"./logo-90min.embedded.svg": 531,
	"./logo-dbltap.embedded.svg": 532,
	"./logo-ei.embedded.svg": 533,
	"./logo-floor8.embedded.svg": 534,
	"./logo-ftb90.embedded.svg": 535,
	"./logo-german_site.embedded.svg": 536,
	"./logo-ht_media.embedded.svg": 537,
	"./logo-pluralist.embedded.svg": 538,
	"./logo-theduel-mobile.embedded.svg": 539,
	"./logo-theduel.embedded.svg": 540,
	"./lol_icon.embedded.svg": 1253,
	"./mdl_icon.embedded.svg": 1254,
	"./melee_icon.embedded.svg": 1255,
	"./mlb_icon.embedded.svg": 1256,
	"./mls_icon.embedded.svg": 1257,
	"./nba_icon.embedded.svg": 1258,
	"./ncaa-basketball_icon.embedded.svg": 1259,
	"./ncaa-football_icon.embedded.svg": 1260,
	"./nfl_icon.embedded.svg": 1261,
	"./overwatch_icon.embedded.svg": 1262,
	"./powered-by-ei.embedded.svg": 541,
	"./powered-by-german_site.embedded.svg": 542,
	"./powered-by-ht_media.embedded.svg": 543,
	"./pubg.embedded.svg": 1263,
	"./smash4_icon.embedded.svg": 1264,
	"./streetfighter_icon.embedded.svg": 1265,
	"./theduel-nav.embedded.svg": 1266,
	"./theduel_menu_icon.embedded.svg": 1267,
	"./world-cup.embedded.svg": 1268,
	"./yousport_icon.embedded.svg": 1269
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1281;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1281
// module chunks = 15